module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-popup', {
    style: ({
      height: '60%'
    }),
    attrs: {
      "position": "bottom",
      "close-on-click-overlay": false
    },
    on: {
      "click-overlay": _vm.onClose
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "address-list-select"
  }, [_c('div', {
    staticClass: "address-add-item",
    on: {
      "click": _vm.addressAdd
    }
  }, [_vm._v("新增收货地址")]), _vm._v(" "), _c('van-cell-group', _vm._l((_vm.list), function(address) {
    return _c('van-cell', {
      key: address.id,
      attrs: {
        "center": "",
        "title": address.name + ' ' + address.phone,
        "is-link": "",
        "label": address.address
      },
      on: {
        "click": function($event) {
          return _vm.onSelect(address)
        }
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '70%'
    }),
    attrs: {
      "position": "bottom"
    },
    on: {
      "click-overlay": _vm.onClose
    },
    model: {
      value: (_vm.showAdd),
      callback: function($$v) {
        _vm.showAdd = $$v
      },
      expression: "showAdd"
    }
  }, [_c('div', {
    staticClass: "address-form"
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "姓名",
      "error": _vm.formValidate && !_vm.formData.name,
      "placeholder": "收货人姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "电话",
      "error": _vm.formValidate && !_vm.formData.phone,
      "type": "number",
      "placeholder": "收货人电话"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "value": _vm.formData.province + _vm.formData.city + _vm.formData.county,
      "error": _vm.formValidate && !_vm.formData.county,
      "label": "地区",
      "placeholder": "选择省/市/区"
    },
    on: {
      "click": function($event) {
        _vm.area_show = true
      }
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "详细地址",
      "error": _vm.formValidate && !_vm.formData.address,
      "placeholder": "街道门牌、楼层房间号等信息"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "设为默认收货地址"
    }
  }, [_c('van-switch', {
    attrs: {
      "size": "24px",
      "active-color": "#f44"
    },
    model: {
      value: (_vm.formData.is_default),
      callback: function($$v) {
        _vm.$set(_vm.formData, "is_default", $$v)
      },
      expression: "formData.is_default"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "distinguish"
  }, [_c('van-field', {
    attrs: {
      "rows": "2",
      "autosize": "",
      "label": "",
      "type": "textarea",
      "placeholder": "智能识别地址"
    },
    model: {
      value: (_vm.distinguish_address),
      callback: function($$v) {
        _vm.distinguish_address = $$v
      },
      expression: "distinguish_address"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "distinguish-btn",
    on: {
      "click": _vm.onSmartParse
    }
  }, [_vm._v("智能识别")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('van-button', {
    attrs: {
      "type": "danger",
      "round": "",
      "size": "large"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.formSave($event)
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.area_show),
      expression: "area_show"
    }],
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "z-index": "1000",
      "width": "100%"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area_key
    },
    on: {
      "confirm": _vm.areaConfirm,
      "cancel": _vm.areaCancel
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-985675a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddressPicker.vue
// module id = 2550
// module chunks = 0